/**
* Copyright 2012-2020, Plotly, Inc.
* All rights reserved.
*
* This source code is licensed under the MIT license found in the
* LICENSE file in the root directory of this source tree.
*/

'use strict';

module.exports = {
    moduleType: 'trace',
    name: 'barpolar',
    basePlotModule: require('../../plots/polar'),
    categories: ['polar', 'bar', 'showLegend'],

    attributes: require('./attributes'),
    layoutAttributes: require('./layout_attributes'),
    supplyDefaults: require('./defaults'),
    supplyLayoutDefaults: require('./layout_defaults'),

    calc: require('./calc').calc,
    crossTraceCalc: require('./calc').crossTraceCalc,

    plot: require('./plot'),
    colorbar: require('../scatter/marker_colorbar'),
    formatLabels: require('../scatterpolar/format_labels'),

    style: require('../bar/style').style,
    styleOnSelect: require('../bar/style').styleOnSelect,

    hoverPoints: require('./hover'),
    selectPoints: require('../bar/select'),

    meta: {
        
        
    }
};
